import { Tooltip } from "@itwin/itwinui-react";
import { runtimeEnv } from "configuration";
import styles from "./VersionBadge.module.css";

export const VersionBadge = ({ version }: { version?: string }) => {
  if (!version || version === runtimeEnv.REACT_APP_PREFERRED_VERSION)
    return null;

  return (
    <Tooltip content={`This sandbox uses an older version of iTwin.js (${version})`} placement="left" delay={500}>
      <div className={styles.versionRibbonContainer}>
        <div className={styles.versionRibbon}>
          <div className={styles.version}>{version}</div>
        </div>
      </div>
    </Tooltip >
  )
};
